import type { ReactNode } from 'react';
import React from 'react';

import { Placement } from '../../../constants';
import { Wrapper } from './Overlay.styled';

interface OverlayProps {
  children: ReactNode;
  placement?: Placement;
}

export const Overlay = ({ children, placement = Placement.CENTER }: OverlayProps) => (
  <Wrapper $placement={placement}>{children}</Wrapper>
);

Overlay.Placement = Placement;
